/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, StiffeningPlanSegmentAnchorLabelsDTO } from '../fastAPI.schemas'

/**
 * The Zuganker and Schubanker labels the stiffening plan export prints per
stiffening segment, for the plan view's preview of that plan.
 * @summary Get Stiffening Plan Anchor Labels
 */
export const getStiffeningPlanAnchorLabels = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<StiffeningPlanSegmentAnchorLabelsDTO[]>({
    url: `/projects/${projectGuid}/stiffening-plan/anchor-labels`,
    method: 'GET',
    signal,
  })
}

export const getGetStiffeningPlanAnchorLabelsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/stiffening-plan/anchor-labels`] as const
}

export const getGetStiffeningPlanAnchorLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>,
      TError,
      TData
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStiffeningPlanAnchorLabelsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>> = ({
    signal,
  }) => getStiffeningPlanAnchorLabels(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetStiffeningPlanAnchorLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>
>
export type GetStiffeningPlanAnchorLabelsQueryError = HTTPValidationError

/**
 * @summary Get Stiffening Plan Anchor Labels
 */

export function useGetStiffeningPlanAnchorLabels<
  TData = Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStiffeningPlanAnchorLabels>>,
      TError,
      TData
    >
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStiffeningPlanAnchorLabelsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
